'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.horizontalCenter = exports.Icon = exports.withBaseIcon = undefined;

var _Icon = require('./Icon');

var _horizontalCenter = require('./horizontalCenter');

exports.withBaseIcon = _Icon.withBaseIcon;
exports.Icon = _Icon.Icon;
exports.horizontalCenter = _horizontalCenter.horizontalCenter;
exports.default = _Icon.Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/index.js
// module id = 66
// module chunks = 0